import { Pipe, PipeTransform } from '@angular/core';
import { DeviceDetectionService } from '../services/device-detection.service';

@Pipe({
    name: 'imageUrl',
    pure: false // Make it impure to react to window resize
})
export class ImageUrlPipe implements PipeTransform {
    private readonly LUXHYPE_IMAGE_DOMAIN = 'media.luxhypefashion.com';

    constructor(private deviceDetection: DeviceDetectionService) { }

    transform(imageUrl: string | null | undefined): string {
        if (!imageUrl) {
            return '';
        }

        // Only process URLs from luxhype media domain
        if (!imageUrl.includes(this.LUXHYPE_IMAGE_DOMAIN)) {
            return imageUrl;
        }

        try {
            // Check if URL already has query parameters
            const url = new URL(imageUrl);
            const width = this.deviceDetection.getImageWidth();

            // Add or update width parameter for both desktop and mobile devices
            // Mobile: w=200, Desktop: w=400
            url.searchParams.set('w', width.toString());

            return url.toString();
        } catch (e) {
            // If URL parsing fails (e.g., relative path or malformed URL), return original
            // This handles edge cases where the URL might not be a complete URL
            return imageUrl;
        }
    }
}

